export default __webpack_public_path__ + "static/media/76.0be93be7.png";